

import { Component } from "vue-property-decorator";
import DevScrumRepository from "@/services/Dev-scrum";
import Vue from 'vue'
import EditAuditForm from "@/services/Dev-scrum/forms/EditAuditForm";
import { ShiftType } from "@/services/Dev-scrum/interfaces";

@Component({
  inject: [
    'devScrumRepository',
  ],
})

export default class EditAudit extends Vue {
  private readonly devScrumRepository!: DevScrumRepository;

  private loading: boolean = true;
  private form: EditAuditForm = new EditAuditForm;

  private shiftOptions = Object.values(ShiftType);
  components: { name: string; id: number | undefined; }[];

  private async created(): Promise<void> {
    const audit = await this.devScrumRepository.getAuditById(Number(this.$route.params.auditId));
    const allComponents = await this.devScrumRepository.getAllComponents();
    const components = allComponents.map(component => {
      return { name: component.name, id: component.id }
    } )

    this.form.date = audit.date;
    this.form.shift = audit.shift;
    this.form.components = audit.components;
    this.components = components;
    this.form.ticket = audit.ticket;
    this.form.time = audit.time;
    this.loading = false;
  }

  private async editAudit(): Promise<void> {
    try {
      await this.devScrumRepository.editAudit(Number(this.$route.params.auditId), {
        date: this.form.date,
        shift: this.form.shift,
        componentIds: this.form.components.map((v) => v.id),
        ticket: this.form.ticket.toUpperCase(),
        time: Number(this.form.time),
      })

      this.$successDialog.show(`Successfully updated audit.`);
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
    }
  }

}
